import React, { useState } from "react";
import EditAddPoll from "components/PollComponent/EditAddPoll/EditAddPoll.js";
import Button from "components/CustomButton";
import PollIconIntro from "assets/img/Poll_Icon_For_Intro_Screen.svg";

export default () => {
  const [dialogState, setDialogState] = useState(false);
  return (
    <>
      <div className="poll-intro-page">
        <img
          src={PollIconIntro}
          alt="Poll Intro"
          className="poll-intro-image"
        />
        <p className="poll-intro-text">
          Create a Poll to better understand your teams. Polls are a great way
          to improve engagement and get more input from the team.
        </p>
        <Button
          onClick={() => setDialogState(true)}
          buttonClass="btn grad_btn addPollButton"
        >
          Create Poll Now
        </Button>
      </div>
      <EditAddPoll
        team={null}
        modelOpen={dialogState}
        createNewPoll={() => {}}
        closeModal={() => setDialogState(false)}
        id={1}
        singleTeam={false}
      />
    </>
  );
};
